import React, { Component } from 'react';
import { Button, Divider, Grid, Paper, TextField } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import SimilarNames from '../shared/SimilarNames';
import SimpleDialogFragment from './SimpleDialogFragment';
import { isUniqueString, similarStrings } from '../../helpers/helpers';

import '../../assets/stylesheets/Setting.css';

class EditSingleFieldModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldName: '',
      error: false,
      similarNames: []
    };
  }

  handleChange = event => {
    const {
      target: { value }
    } = event;

    const { existingFieldNames } = this.props;

    const error = !isUniqueString(value, existingFieldNames);

    const similarNames = similarStrings(value, existingFieldNames);

    this.setState({
      fieldName: value,
      error,
      similarNames
    });
  }

  handleEdit = () => {
    const { fieldName } = this.state;
    const { onSave } = this.props;
    if (fieldName.trim() === '') {
      this.setState({ error: true });
    } else {
      onSave(fieldName);
    }

  }

  render() {
    const {
      selectedItem,
      showModal,
      title,
      onClose,
      warningText,
    } = this.props;
    const { error, fieldName, similarNames } = this.state;
    const safeFieldName = fieldName === '' ? selectedItem : fieldName;

    if (selectedItem == null) {
      return (
        <Modal open={showModal} onClose={onClose}>
          <Paper className="editModal">
            <SimpleDialogFragment
              title={warningText}
              buttonLabel={i18n.t('close')}
              onClick={onClose}
            />
          </Paper>
        </Modal>
      )
    }

    return (
      <Modal open={showModal} onClose={onClose}>
        <Paper className="editModal">
          <div>
            <span>{title}</span>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  onChange={this.handleChange}
                  name="editName"
                  value={safeFieldName}
                />
                <Divider />
                <br />
              </Grid>
              <SimilarNames similarNames={similarNames} divider />
              <Grid item xs={6}>
                <Button
                  onClick={this.handleEdit}
                  disabled={error}
                  className="ssenseButton ssensePrimary"
                >
                  {i18n.t('save')}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={onClose}
                  className="ssenseButton ssenseDefault"
                >
                  {i18n.t('cancel')}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Modal>
    )
  }
}

EditSingleFieldModal.defaultProps = {
  selectedItem: null
}

EditSingleFieldModal.propTypes = {
  selectedItem: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  existingFieldNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  warningText: PropTypes.string.isRequired,
}

export default EditSingleFieldModal;
